import { createTheme } from "@mui/material";
export const getMuiTheme = (overrides = {}) =>
    createTheme({
        components: {
            MuiTableSortLabel: {
                styleOverrides: {
                    root: {
                        '& .MuiTableSortLabel-icon': {
                            display: 'none !important', // Hide default icon
                        },
                        '&.Mui-active .MuiTableSortLabel-iconDirectionAsc': {
                            backgroundImage: 'url(/admin-images/new_bottom_arrow_icon3.svg) !important',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            display: 'block !important',
                            backgroundColor: 'transparent',
                            border: 'none',
                        },
                        '&.Mui-active .MuiTableSortLabel-iconDirectionDesc': {
                            backgroundImage: 'url(/admin-images/new_bottom_arrow_icon3.svg) !important',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            display: 'block !important',
                            backgroundColor: 'transparent',
                            border: 'none',
                        },
                    },
                },
            },
            MUIDataTableToolbar: {
                    styleOverrides: {
                        filterPaper: {
                            width: "450px",
                            marginTop: "20px",
                            marginRight: "20px"
                        },
                },
            },
            MUIDataTableFilterList: {
                styleOverrides: {
                  root: {
                    marginBottom: 10
                  },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        '&:last-child': {
                            position: 'sticky',
                            right: 0,
                            zIndex: 1201,
                            backgroundColor: "#edf0f8",
                            width: "1%", 
                            borderBottom: '1px solid #afafaf36!important',
                        },
                        '&:first-child': {
                            backgroundColor: "#edf0f8",
                            width: "1%", 
                            textAlign: "center",
                            paddingLeft: 0,
                            paddingRight: 0,
                            borderBottom: '1px solid #afafaf36!important',
                            "& .MuiButtonBase-root": {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: 0,
                                padding: 0,
                                width: "100%",
                            },
                            "& .custom-label-datatable": {
                                color: "#00a2e3",
                                textAlign: 'center'
                            },
                        },
                    },
                    root: {
                        borderRight: "1px solid #eeeeee",
                        "&:last-child": {
                            borderRight: "none",
                            backgroundColor: "#edf0f8",
                            borderBottom: '1px solid #afafaf36!important',
                            position: 'sticky',
                            right: 0,
                            zIndex: 1201,
                        },
                        "&:first-child": {
                            textAlign: "center",
                            borderRight: "none",
                            backgroundColor: "#edf0f8",
                            borderBottom: '1px solid #afafaf36!important',
                            "& .custom-text-datatable": {
                                color: "#00a2e3"
                            },
                        },
                    },
                },
            },
            MuiList: {
                styleOverrides: {
                  root: {
                    maxHeight: "300px"
                  },
                },
              },
              MuiToolbar: {
                styleOverrides: {
                  root: {
                    padding: '0px!important',
                    backgroundColor: "transparent",
                    alignItems: "flex-start",
                    minHeight: '48px !important'
                  },
                },
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        "&:nth-of-type(odd)": {
                            backgroundColor: "#fff",
                        },
                        "&:nth-of-type(even)": {
                            backgroundColor: "#f5f5f5",
                        },
                        "&:nth-of-type(even):hover": {
                            backgroundColor: "#f5f5f5",
                        },
                        "&:nth-of-type(odd):hover": {
                            backgroundColor: "#fff",
                        },
                    },
                },
            },
            MUIDataTableFooter: {
                styleOverrides: {
                    root: {
                        backgroundColor: "#fff"
                    }
                }
            },
            ...overrides,
        },
    });